import { push } from 'connected-react-router';
import { fetchGoods } from './features/common/effects';

export const setSubscribes = (store) => {
  const { dispatch } = store;

  const observer = new window.POPObserver();

  observer.addEventListener('ON_CHANGE_PAYMENT_STATUS_STORE', (status) => {
    if (status === 'succeeded') {
      dispatch(fetchGoods());
    }
  });

  observer.addEventListener('ON_ROUTE_CABINET', (route) => dispatch(push(route)));
};
